import {ValueObject} from '@s-ui/domain'

export default class ContactResponseValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.contactToken
   * @param {String} data.contactUserId
   * @param {String} data.literal
   * @param {String} data.status
   * */
  getContactToken() {
    return this._contactToken
  }
}
